import { combineReducers } from 'redux';
import info from './Information/reducer';
import bankAccount from './BankAccount/reducer';
import cryptoWallets from './CryptoWallets/reducer';
export default combineReducers({
  info,
  bankAccount,
  cryptoWallets
});
